import { render, staticRenderFns } from "./base-statistics.vue?vue&type=template&id=70ae9b3a&lang=pug"
import script from "./base-statistics.vue?vue&type=script&lang=js"
export * from "./base-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports